import React, { FC } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

/**
 * Raised while the window is open, so a second editor is discovered in seconds rather than at the save.
 * A banner rather than a dialog: it must not interrupt someone mid-selection.
 */
const BimboShareChangeBanner: FC<{
    show: boolean
    onReload: () => void
    onDismiss: () => void
}> = ({ show, onReload, onDismiss }) => {
    const { t } = useTranslation()

    if (!show) {
        return null
    }

    return (
        <Alert
            variant="warning"
            dismissible
            onClose={onDismiss}
            className="bimbo-share-notice d-flex align-items-center justify-content-between mb-2"
        >
            <span>
                <i className="fa-solid fa-triangle-exclamation me-2"></i>
                {t('app.bimboShareForm.liveNotice.changed')}
            </span>
            <span className="bimbo-share-notice-actions text-nowrap">
                <Button variant="link" onClick={onDismiss}>
                    {t('app.bimboShareForm.liveNotice.dismiss')}
                </Button>
                <Button variant="warning" onClick={onReload}>
                    {t('app.bimboShareForm.liveNotice.reload')}
                </Button>
            </span>
        </Alert>
    )
}

export default BimboShareChangeBanner
